export const checkboxes = [
    {
      name: "polyuria",
      key: "polyuria",
      label: "polyuria"
    },
    {
      name: "polydipsia",
      key: "polydipsia",
      label: "excessive thirst"
    },
    {
      name: "weakness",
      key: "weakness",
      label: "weakness"
    },
    {
      name: "genital_thrush",
      key: "genital_thrush",
      label: "genital thrush"
    },
    {
      name: "itching",
      key: "itching",
      label: "itching"
    },
    {
      name: "irritability",
      key: "irritability",
      label: "irritability"
    },
    {
      name: "delayed_healing",
      key: "delayed_healing",
      label: "delayed healing"
    },
    {
      name: "alopecia",
      key: "alopecia",
      label: "alopecia"
    },
    {
      name: "obesity",
      key: "obesity",
      label: "obesity"
    }
    
  ]